export default __webpack_public_path__ + "static/media/calendar.2fb5f64f.svg";